import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import FloatingContacts from './components/FloatingContacts';
import SolarPower from './components/SolarPower';
import WindEnergy from './components/WindEnergy';
import Hydroelectric from './components/Hydroelectric';
import EnergyStorage from './components/EnergyStorage';
import Consulting from './components/Consulting';
import SupportingServices from './components/SupportingServices';
import OurProcess from './components/OurProcess';
import Blog from './components/blog';
import BlogPost from './components/BlogPost';
import SiteMap from './components/SiteMap';



function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/solar" element={<SolarPower />} />
            <Route path="/services/wind" element={<WindEnergy />} />
            <Route path="/services/hydro" element={<Hydroelectric />} />
            <Route path="/services/storage" element={<EnergyStorage />} />
            <Route path="/services/consulting" element={<Consulting />} />
            <Route path="/services/supporting" element={<SupportingServices />} />
            <Route path="/services/process" element={<OurProcess />} />
            <Route path="/contact" element={<Contact />} />
             
     <Route path="/blog" element={<Blog />} />
    <Route path="/blog/:postId" element={<BlogPost/>} />
            <Route path="/sitemap" element={<SiteMap />} />
          </Routes>
          <FloatingContacts />
        </main>
        <Footer />
    </div>
    </Router>
  );
}

export default App;
